import React from 'react';

const ShippingPolicy = () => {
  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>
      <h2 style={{ textAlign: 'center', color: '#333' }}>Shipping Policy</h2>
      <p style={{ textAlign: 'center', color: '#555' }}>
        We are committed to delivering your products within 7 days. Please ensure that your address 
        and contact details are accurate to facilitate timely delivery. Thank you for choosing us!
      </p>
    </div>
  );
};

export default ShippingPolicy;
